// extracted by mini-css-extract-plugin
export var linkText = "_lp-0";